<style lang="scss">
.menu-title {
	cursor: pointer;
	user-select: none;
	padding: 2px 12px 2px 6px;
	float: unset !important;
	&:hover {
		background-color: #d5e8fc;
	}
}

.menu-node-btn {
	display: inline-block;
	float: right;
	button {
		margin-right: 8px;
	}
}

.menu-title-active {
	background-color: #d5e8fc;
}
</style>

<template>
	<div>
        <vInput
			class="menu-search"
			v-model="search"
			@on-enter="handleInput"
			suffix="search"
			@on-icon-click="handleInput"
			placeholder="支持code, name等搜索"
		></vInput>
		<vTree
			style="min-height:70vh;"
			:data="getNodes"
			:render="renderNode"
			ref="tree"
		></vTree>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { HttpBillingCategory } from '@/service/newbigaccount';
import { HttpCategory } from '@mods/service/dictionary';

export default {
	data() {
		return {
            search:'',
			operateId: null,
			linkIndex: "",
            dataList:'',
            categoryList:[],
		};
    },
    created(){
        this.update()
    },
	computed: {
		// ...mapGetters('dictionary', ['getBillcategory']),
		getNodes() {
			const data = JSON.parse(JSON.stringify(this.categoryList))
			const Nodes = [];
			data.forEach(item => {
                if(item.type == 1) return
				const parentId = item.parentId;
				if (!parentId) return Nodes.push(item);
				const parent = data.find(function (item) {
					return parentId === item.id;
				});
				if (!parent) return;
				const children = parent.children;
				if (children) {
					children.push(item);
				} else {
					parent.children = [item];
				}
			});
			Nodes.forEach((item) => {
				item.expand = true;
			})
			return Nodes;
		},
	},
	methods: {
        update(){
            HttpBillingCategory().then(res=>{
                this.categoryList = res.data
            })
        },
        handleInput (val) {
            let indistinctTarget,
				target = this.getBillcategory.find(function (item) {
					if (!indistinctTarget && val && `${item.name}`.indexOf(val) > -1 && `${item.name.toLowerCase().indexOf(val.toLowerCase()) > -1}`) indistinctTarget = item;
					return val && (val == item.code || val == item.name || val == item.nameEn || item.name.toLowerCase().indexOf(val.toLowerCase()) > -1);
				}) || indistinctTarget;
            if (target) {
				this.$refs.tree.initStatus(['id', this.operateId = target.id]);
				// this.$emit('on-data', target, 'edit');
				setTimeout(() => {
					const ele = document.querySelector(`.vview-treenode-li[data-id="${this.operateId}"]`);
					ele.scrollIntoView({ block: "center" });
				}, 600)
			}
        },
		renderNode(h, { root, node, data })
		{
            if(data.type == 0){
                let active = this.operateId === data.id;

                return h('div', {
                    class: [
                        'menu-title',
                        {
                            'menu-title-active': active
                        }
                    ],

                    attrs: {
                        title: this.$t('fbb.accountmanage.double_click_edit_node', { defaultValue: "双击编辑该节点" })
                    }
                }, [data.name,
                h('span', {
                    class: 'menu-node-btn'
                },
                    [
                        data.level < 3 ? h('vButton', {
                            attrs: {
                                title: this.$t('fbb.accountmanage.add_child_node', { defaultValue: "添加子节点" }),
                                icon: 'add',
                                theme: 'primary',
                                size: 'small',
                            },
                            on: {
                                click: (event) => {
                                    event.stopPropagation();
                                    this.appendNode(root, node, data);
                                },
                            },
                        }) : null,

                        data.parentId && (data.level > 1) ? h('vButton', {
                            props: {
                                icon: 'create',
                                size: 'small',
                            },
                            attrs: {
                                title: this.$t('fbb.accountmanage.edit_node', { defaultValue: "编辑该节点" })
                            },
                            on: {
                                click: (event) => {
                                    event.stopPropagation();
                                    this.getNode(root, node, data,'edit');
                                },
                            },
                        }) : null,

                        data.parentId && (data.level > 1) ? h('vButton', {
                            props: {
                                icon: 'settings',
                                size: 'small',
                            },
                            attrs: {
                                title: '添加计费规则'
                            },
                            on: {
                                click: (event) => {
                                    event.stopPropagation();
                                    this.getNode(root, node, data,'setting');
                                },
                            },
                        }) : null,

                        data.parentId && (data.level > 1) ? h('vButton', {
                            props: {
                                icon: 'remove',
                                size: 'small',
                            },
                            attrs: {
                                title: '删除节点'
                            },
                            on: {
                                click: (event) => {
                                    event.stopPropagation();
                                    this.getNode(root, node, data,'delete');
                                },
                            },
                        }) : null,
                    ]
                ),
                ])
            }
		},
		handleKeepStatus() {
			if (linkIndex) {
				this.$refs.tree.status = linkIndex.split(',')
			}
		},
		getNode(root, node, data,type) {
			// console.log(node, data)
			this.operateId = data.id;
			this.$emit('on-data', data, type);
		},
		appendNode(root, node, data) {
			// console.log(data.level)
			this.operateId = data.id;
			this.$emit('on-data', data, 'add');
		},
	},
};
</script>
